export default __webpack_public_path__ + "static/media/noexpl_014_DE.7d51641c.png";